export default "__VITE_ASSET__Dx4JgWHW__"